import React from 'react';
import Hero from './Hero';
import Contact from '../Contact/Contact'
import About from '../About/About'
import Properties from '../Properties/Properties';


function Home(){
    return(
    <div className='Home'>
        <Hero/>

        <About/>
        
        <Properties/>
        
        <Contact/>
        
    </div>
    );
}

export default Home;